import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ProtectedRoute, PublicOnlyRoute } from './RoleRoutes'; // Импортируем обертки
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from './AuthContext'; // Импортируем AuthProvider
import { DateProvider } from './DateContext';
import { ProjectProvider } from './ProjectContext.js';
import Home from './components/Home.jsx';
import Navbar from './components/Navbar';  // Импорт Navbar
import useServiceWorkerUpdater from './useServiceWorkerUpdater';
import CookieConsentBanner from './components/CookieConsentBanner.jsx';
// import MetrikaTracker from './components/MetrikaTracker.jsx';
import Loader from './components/Loader.jsx';
import { getConsent, setConsent } from './analytics/cookieConsent';

const Logout = lazy(() => import('./components/Logout'));
const Login = lazy(() => import('./components/Login'));
const GoRedirect = lazy(() => import('./components/Go.jsx'));
const PulseRefRedirect = lazy(() => import('./components/PulseRefRedirect.jsx'));
const ProfileCabinet = lazy(() => import('./components/profile/ProfileCabinet.jsx'));
const Dashboard = lazy(() => import('./components/Dashboard.jsx'));
const Register = lazy(() => import('./components/Register.jsx'));
const QrCode = lazy(() => import('./components/QRcode.jsx'));
const PaymentConstructor = lazy(() => import('./components/PaymentConstructor.jsx'));
const CheckoutPage = lazy(() => import('./components/CheckoutPage.jsx'));
const SuccessPage = lazy(() => import('./components/SuccessPage.jsx'));
const ResetPasswordRecoveryForm = lazy(() => import('./components/profile/ResetPasswordRecoveryForm.jsx'));
const CabinetResetPasswordForm = lazy(() => import('./components/profile/CabinetResetPasswordForm.jsx'));
const EmailConfirmPage = lazy(() => import('./components/EmailConfirmPage.jsx'));
const EmailChangePage = lazy(() => import('./components/profile/EmailChangePage.jsx'));



function App() {

  const { showReload, reloadPage } = useServiceWorkerUpdater(); 
  const [consent, setConsentState] = useState(() => getConsent());
  // const analyticsAllowed = consent === 'accepted';
  
  // App.jsx
console.log("Версия билда: 1.0.2");

  const handleAcceptCookies = () => {
    setConsent('accepted');
    setConsentState('accepted');
  };

  const handleDeclineCookies = () => {
    setConsent('declined');
    setConsentState('declined');
  };

  function NotFound() {
  return (
    <div>
      <h1>404</h1>
      <p>Страница не найдена</p>
    </div>
  );
}


  return (
    <AuthProvider>
          <ProjectProvider>
          <DateProvider>
              <div className='body' style={{ overflow: "hidden" }}>

                  <Router >
                    {/* <MetrikaTracker analyticsAllowed={analyticsAllowed} /> */}
                    <Navbar/>
                    <Suspense fallback={<Loader />}>
                      <Routes>
                        {/* Публичные страницы, доступные всем и всегда */}
                        <Route path="/" element={<Home />} />
                        <Route path="/go" element={<GoRedirect />} />
                        <Route path="/b/:pulse_referrer" element={<PulseRefRedirect />} />
                        <Route path="/success" element={<SuccessPage />} />
                        <Route path="/reset-password" element={<ResetPasswordRecoveryForm />} />
                        <Route path="/email-confirm" element={<EmailConfirmPage />} />
                        <Route path="/email-change-confirm" element={<EmailChangePage />} />

                        {/* Страницы ТОЛЬКО для гостей (авторизованных отсюда выкинет в /dashboard) */}
                        <Route path="/login" element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
                        <Route path="/register" element={<PublicOnlyRoute><Register /></PublicOnlyRoute>} />

                        {/* Защищенные страницы (гостей отсюда выкинет на главную "/") */}
                        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                        <Route path="/logout" element={<ProtectedRoute><Logout /></ProtectedRoute>} />
                        <Route path="/profilecabinet" element={<ProtectedRoute><ProfileCabinet /></ProtectedRoute>} />
                        <Route path="/qrcode" element={<ProtectedRoute><QrCode /></ProtectedRoute>} />
                        <Route path="/payment" element={<ProtectedRoute><PaymentConstructor /></ProtectedRoute>} />
                        <Route path="/checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
                        <Route path="/profilecabinet/reset-password" element={<ProtectedRoute><CabinetResetPasswordForm /></ProtectedRoute>} />

                        {/* 404 */}
                        <Route path="*" element={<NotFound />} />

                      </Routes>
                    </Suspense>
                  </Router>
                  <ToastContainer
                        position="top-right"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                       {/* 🔄 Баннер для обновления */}
            {showReload && (
              <div style={{
                position: 'fixed',
                bottom: 0,
                width: '100%',
                backgroundColor: '#222',
                color: '#fff',
                padding: '12px',
                textAlign: 'center',
                zIndex: 1000,
              }}>
                Доступна новая версия сайта. <button onClick={reloadPage} style={{
                  marginLeft: '10px',
                  padding: '6px 12px',
                  backgroundColor: '#0d6efd',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}>Обновить</button>
              </div>
            )}
            <CookieConsentBanner
              visible={!consent}
              onAccept={handleAcceptCookies}
              onDecline={handleDeclineCookies}
            />
                    </div>
                </DateProvider>                  
          </ProjectProvider>
        </AuthProvider>

    
  );
}

export default App;
